import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../Table";
import { IAgendaCompromisso } from "../../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import SpinnerComponent from "../../../Loding/Spinner";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import DescricaoEventoAgendamento from "../../../../Pages/AssistenciaTecnica/AgendaAssistenciaTecnica/DescricaoEventoAgendamento";

export function Agendados(props: any) {
    const tableviewColumns: Array<ColumnDescription<IAgendaCompromisso>> = [
        {
            dataField: "Ver Evento",
            text: "Ação",
            isDummyField: true,
            formatter: (_, row) => {
                return (
                    <>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-evento-tooltip">
                                    Ver Evento
                                </Tooltip>
                            }
                        >
                            <button
                                className="m-2 btn btn-icon btn-outline-info"
                                onClick={() => {
                                    props.setModal({
                                        Children: (
                                            <DescricaoEventoAgendamento
                                                agendamento={row}
                                            />
                                        ),
                                        IconHeader: faCalendar,
                                        headerComponent: "Evento",
                                        noHeader: true,
                                        noFooter: true,
                                    });
                                    props.setShow(true);
                                }}
                            >
                                <i className="icon-xl far fa-eye"></i>
                            </button>
                        </OverlayTrigger>
                    </>
                );
            },
        },
        {
            dataField: "DS_TIPO_COMPROMISSO",
            text: "Tipo Compromisso",
        },
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Produto",
        },
        {
            dataField: "DS_NOME",
            text: "Usuário",
        },
        {
            dataField: "DT_INICIO",
            text: "Data início",
            formatter: (_, row) => {
                return <>{moment(row.DT_INICIO).format("LLL")}</>;
            },
        },
        {
            dataField: "DT_FIM",
            text: "Data fim",
            formatter: (_, row) => {
                return <>{moment(row.DT_FIM).format("LLL")}</>;
            },
        },
    ];

    return (
        <>
            {props?.lstAgendamentos ? (
                <div className="card-body pt-2 pb-0 mt-n3">
                    <div className="table-responsive-sm">
                        <Table
                            keyField="ID_COMPROMISSO"
                            columns={tableviewColumns}
                            wrapperClasses="mw-100 custom-scroll"
                            tableView={{
                                columns: tableviewColumns,
                                sizePerPage: 10,
                                cancelYScroll: true,
                                defaultStyle: true,
                                striped: true,
                            }}
                            data={props.lstAgendamentos ?? []}
                            loading={props.lstAgendamentosLoading}
                            totalPages={Math.ceil(
                                props.lstAgendamentos.length / 10
                            )}
                            noDataIndication={() => (
                                <div className="text-black-50 text-center">
                                    Nenhum Agenda Encontrado
                                </div>
                            )}
                            rowStyle={{ height: 50 }}
                            defaultStyle={{ align: "center" }}
                            striped={true}
                            rowClasses={"rowClasses"}
                            noHover
                            center={true}
                        />
                    </div>
                </div>
            ) : (
                <>
                    <SpinnerComponent />
                </>
            )}
        </>
    );
}
